<div class="ar-model-dialog">
    <app-new-ar-model [selectedFloorPlanId]="selectedFloorPlanId"></app-new-ar-model>
    <div class="ar-model-dialog-close">
        <button class="ar-model-dialog-close-button" mat-button (click)="closeDialog()">
            Close
        </button>
    </div>
</div>
